<template>
    <div class="modal-mask">



<div id="uploadContainer" ref="uploadContainer"></div>
      <div v-on:click.self="createStop" class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">

            <h2>Create a new factsheet</h2>
            <button type="button" class="btn btn-link" @click.prevent="createStop" style="color:#666;position:relative;top:-7px;right:-10px;;font-size:1.3em;"><i class="bi bi-x-lg"></i></button>

          </div>
          <p>
            You can create a new factsheet by choosing one of the methods below.
          </p>
          <div v-show="apiStatus==0" class="modal-progress">
              <p>Checking if we can create a new factsheet for you right now...</p>
          </div>
          <div v-show="apiStatus==2" class="modal-progress">
              <p>Sorry, creating new factsheets is currently not possible. This could be due to technical problems, or that we're
              doing maintentance to our systems at the moment. <br/><br/>Please try again in a few minutes or contact support@geofolio.org if the problem persists.</p>
          </div>
          <div v-show="apiStatus==1" style="min-height:450px;">


            <div>
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a :class="createMode=='draw' ? 'nav-link active' : 'nav-link'" href="#" @click.prevent="doDraw"><i class="bi bi-share-fill"></i>&nbsp;&nbsp;Draw an area</a>
                </li>
                <li class="nav-item">
                  <a :class="createMode=='upload' ? 'nav-link active' : 'nav-link'" href="#" @click.prevent="doUpload"><i class="bi bi-upload"></i>&nbsp;&nbsp;Upload a file</a>
                </li>
                <li class="nav-item">
                  <a :class="createMode=='search' ? 'nav-link active' : 'nav-link'" href="#" @click.prevent="doSearch"><i class="bi bi-search"></i>&nbsp;&nbsp;Search for places</a>
                </li>
                <li class="nav-item">
                  <a :class="createMode=='water' ? 'nav-link active' : 'nav-link'" href="#" @click.prevent="doWater"><i class="bi bi-droplet"></i>&nbsp;&nbsp;Find a watershed</a>
                </li>

                <li class="nav-item" v-show="(profile && profile.is_admin)">
                  <a :class="createMode=='advanced' ? 'nav-link active' : 'nav-link'" href="#" @click.prevent="doAdvanced"><i class="bi bi-gear"></i> Advanced</a>
                </li>
              </ul>


            </div>
            <div class="modal-body">

                <div v-show="createMode=='draw'" style="min-height:65px;" class="row align-items-center">
                  <div class="col-12">
                  <p>
                  To draw an area of interest, click the map tiles to zoom in until the draw buttons appear. You can then draw a polygon or rectangle.
                  </p>
                  </div>
                </div>



              <div v-show="(profile && profile.is_admin && createMode=='advanced')" style="min-height:65px;padding-top:10px;" class="row align-items-center">

                <div class="col-12">
                  <form style="padding:0px 10px;">
                    <div class="form-group row align-items-center no-gutters">
                      <label for="inputEmail3" class="col-sm-2 col-form-label">Type:</label>
                      <div class="col-sm-10">
                        <div class="form-check" v-for="fst in profile.allowed_factsheettypes">
                          <input v-model="factsheettype_requested" class="form-check-input" type="radio" :id="'fst_'+fst.name" :value="fst.name" checked>
                          <label class="form-check-label" :for="'fst_'+fst.name">{{fst.title}} (Max size: {{fst.max_size}} sq. km.)</label>
                        </div>

                      </div>
                    </div>
                    <div class="form-group row  align-items-center no-gutters">
                      <label for="inputEmail3" class="col-sm-2 col-form-label">Geometry:</label>
                      <div class="col-sm-10">
                        <textarea v-model="geom" style="background-color:#f5f5f5;width:100%;font-family:monospace;border:1px solid #ccc;color:#666;height:80px;line-height:12px;"></textarea>
                        <!-- <input type="button" style="font-size:0.7em;border:1px solid #ccc;" class="btn btn-light btn-sm" value="Suggest WKT"> -->
                      </div>
                    </div>
                  </form>
  

                  </div>
                  
                

              </div>

              <div v-show="createMode=='water'" style="min-height:65px;" class="row align-items-center">
                  <div class="col-8">
                  <p>
                  To delineate an approximate watershed, click the map in any location and we'll merge the upstream catchments for you.
                  </p>
                  </div>
                  <div class="col-4" style="padding-right:25px;">
                  
                    <button v-if="!waterBusy" type="button" ref="btnWatershed" id="btnUpload" class="btn btn-block btn-outline-secondary" disabled style="border:1px solid #aaa;">Waiting for click...</button>

                    <button v-if="waterBusy" type="button" ref="btnWatershed" id="btnUpload" class="btn btn-block btn-outline-secondary" disabled style="border:1px solid #aaa;">Searching, please wait...</button>
                    </div>
                </div>

                

                <div v-show="createMode=='upload'"  style="min-height:90px;" class="row align-items-center">
                  <div class="col-8">
                  <p>
                    All the features in the uploaded file will be dissolved into a single multipolygon which defines your area of interest.<br/><small style="color:#999;"><i class="bi bi-file-earmark"></i> Max. 10Mb Shapefile (Zipped), KML, GeoJSON, or GeoPackage.</small>
                  </p>
                  </div>
                  <div class="col-4" style="padding-right:25px;">
                    <button v-show="!uploading" type="button" ref="btnUpload" id="btnUpload" class="btn btn-block btn-primary"><i class="bi bi-upload"></i>&nbsp;&nbsp;Select a file...</button>
                    <button v-show="uploading" type="button" id="btnUploadWait" class="btn btn-block btn-outline-secondary disabled" disabled style="border:1px solid #aaa;"><i class="bi bi-hourglass"></i>&nbsp;&nbsp;Uploading...</button>  
                  </div>
                </div>
                <div v-show="createMode=='search'"  style="min-height:60px;" class="row align-items-center">
                  <div class="col-8" style="margin-right:0px;">
                    <input type="text" class="form-control" v-on:keyup.enter="searchFor" ref="searchInput" v-model="searchQuery" placeholder="Yellowstone National Park, Oxfordshire, etc." style="border-radius:0px;margin:0px 10px 0px 10px;">
                    
                  </div>
                  <div class="col-4" style="padding-right:25px;">
                    <button v-if="!searchBusy" type="button" id="btnSearch" class="btn btn-block btn-primary"  @click.prevent="searchFor"><i class="bi bi-search"></i>&nbsp;&nbsp;Search</button>  
                    <button v-if="searchBusy" type="button" id="btnSearch" class="btn btn-block btn-outline-secondary" disabled style="border:1px solid #aaa;">Searching, please wait...</button>  
                  </div>



                </div>

                <div class="searchResults" v-show="(searchResults.length > 0) && createMode=='search'">
                  <div class="searchResultsWrapper">
    
                    <table class="searchResultsTable">
                      <tr style="display:none;">
                      <th>Area</th>
                        <th class="name">Name</th>
                        <th>Type</th>
                        
                      </tr>
                      <tr v-for="result in searchResults">
                        <td style="color:#aaa;">
                          <span v-if="(result.area < (areaLimitMax*1000000)) && (result.area > (areaLimitMin*1000000))" style="color:#15b01a">
                            <i class="bi bi-check-circle"></i> {{result.area|km2}}
                          </span>
                          <span v-else style="color:#888">
                            <i class="bi bi-exclamation-circle"></i> {{result.area|km2}}
                          </span>
                        </td>
                        <td class="name">
                          <a href="#" @click.prevent="proposeSearchResult(result)" v-if="(result.area < (areaLimitMax*1000000)) && (result.area > (areaLimitMin*1000000))">{{result.name}}</a>
                          <span v-else style="color:#888;">{{result.name}}</span>
                        </td>
                        <td>{{result.type}}</td>
                        
                      </tr>
                    </table>

                  </div>

                </div>

                
                
                <div ref="map" class="map"></div>



              


            </div>
            
          </div>

              <div class="container statusContainer" :style="statusContainerStyle">
                <div class="row align-items-center no-gutters" style="">
                  <div class="col-12">

                    <span v-if="statusMessage" :style="statusStyle">
                      <i style="font-size:1.3em;position:relative;top:2px;" v-show="statusType=='success'" class="bi bi-check-circle-fill"></i>
                      <i style="font-size:1.3em;position:relative;top:2px;" v-show="statusType=='error'" class="bi bi-exclamation-circle-fill"></i>                      
                      <i style="font-size:1.3em;position:relative;top:2px;" v-show="statusType=='info'" class="bi bi-info-circle-fill"></i>
                      <strong style="font-size:1.05em;padding-left:5px;" v-html="statusMessage"></strong>
                    </span>
                  </div>
                </div>
              </div>

          
          
          <div class="modal-footer">

              <div class="container" style="padding:0px;margin-top:5px;">
                


                <div class="row align-items-center">
                  <div class="col-8">


                    <input class="form-control" ref="areaNameInput" v-on:keyup.enter.prevent="generateFactsheet" v-model="areaName" placeholder="Enter an (optional) name for your area..." style="border-radius:0px;background-color:#fff;width:100%;border:1px solid #ccc;color:#666;height:40px;"></input>
                  </div>
                  <div class="col-4">

                    <div v-if="((geomValid || createMode=='advanced') && (apiStatus==1) && (!working))">
                      <button ref="btnSubmit" @click.prevent="generateFactsheet" type="button" class="btn btn-block btn-success" style="height:40px;font-weight:bold;font-size:1.05em;"><i class="bi bi-stars"></i>&nbsp;&nbsp; Create new factsheet</button>
                    </div>
                    <div v-else>
                      <button type="button" class="btn btn-block btn-outline-secondary" disabled style="height:40px;border:1px solid #aaa;font-size:1.05em;font-weight:bold;"><i class="bi bi-stars"></i>&nbsp;&nbsp; Create new factsheet</button>
                    </div>

                  </div>
                </div>

                <p style="font-size:0.8em;color:#888;line-height:18px;margin:0px;padding-top:10px;">Background map and placename search by OpenStreetMap/Nominatim contributors. Watershed search based on WWF HydroBASINS data. Get in touch via support@geofolio.org if your upload is not working or you're having difficulties defining your area of interest.</p>
              </div>



          </div>
        </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */
import Leaflet from 'leaflet';
import "leaflet/dist/leaflet.css";
import LeafletDraw from 'leaflet-draw'
import "leaflet-draw/dist/leaflet.draw.css";
import Dropzone from 'dropzone';
Dropzone.autoDiscover = false;
import {parse, stringify} from 'wellknown';
import omnivore from "@mapbox/leaflet-omnivore";

  export default {
    name: 'Create',
    data() {
      return {
        geom: null,
        geomValid: false,
        error: null,
        working: false,
        csrfToken: null,
        notice: null,
        progress: 0,
        drawControl: null,
        drawActive: false,
        drawHint: false,
        progressMessage: 'Starting up...',
        uploadMessage: null,
        errorMessage: null,
        factsheettype_requested: 'basic',
        apiStatus:0,
        createMode: 'draw',
        uploading: false,
        statusMessage: null,
        statusType: null,
        searchQuery: '',
        searchBusy: false,
        searchResults: [],
        areaLimitMin: 20,
        areaName: "",
        areaNameCustom: "",
        areaNameDefault: null,
        waterBusy: false
      }
    },
    created() {


    },
    mounted() {
      this.$axios
         .get(process.env.VUE_APP_API+"/api/profile", {}, {timeout:4})
         .then(response => {
            if (response.data.status == 1) {
              this.apiStatus = 1;
              this.initializeChooseArea();
            } else {
              this.apiStatus = 2;
              this.initializeChooseArea();
            }
         })
         .catch(error => {
            this.apiStatus = 2;
            this.initializeChooseArea();
         })
    },
    computed: {
        areaLimitMax() {
          var areaLimitMax = 15000;
          this.profile.allowed_factsheettypes.forEach((ft) => {
            if (ft.name == this.factsheettype_requested) {
              areaLimitMax = ft.max_size
            }
          });
          return areaLimitMax;
        },
        statusStyle() {
          if(this.statusType == 'success') {
            return "color:#218838;"
          }
          if(this.statusType == 'error') {
            return "color:#e50000";
          }
          if(this.statusType == 'info') {
            return "color:#047495;"
          }
          return "color:#666";
        },
        statusContainerStyle() {
          if(this.statusType == 'success') {
            return "background-color:rgba(33, 136, 56, 0.1);"
          }
          if(this.statusType == 'error') {
            return "background-color:rgba(229, 0, 0, 0.1)";
          }
          if(this.statusType == 'info') {
            return "background-color:rgba(4, 116, 149, 0.1)"
          }
          return "";
        },
        profile() {
            return this.getProfile();
        }
    },
    filters: {
      km2: function (value) {
        return (value/1000000).toFixed(0)+'km²';
      },
    },
    methods: {
      doDraw() {
        this.createMode='draw';
        this.uploadStop();
        this.searchStop();
        this.waterStop();
        this.drawStart();
      },
      doUpload() {
        this.createMode='upload';
        /* first stop any drawing activities that may be going on.... */
        this.drawStop();
        this.waterStop();
        this.searchStop();
        this.uploadStart();
      },
      doSearch() {
        this.drawStop();
        this.uploadStop();
        this.waterStop();
        this.searchStart();
        this.createMode='search';
      },
      doWater() {
        this.drawStop();
        this.uploadStop();
        this.searchStop();
        this.waterStart();
        this.createMode='water';
      },
      doAdvanced() {
        this.createMode='advanced';
      },
      waterStart() {
        this.statusMessage = 'Click the map anywhere to delineate an approximate watershed.'
        this.statusType = 'info'
      },
      waterStop() {
        this.geom = null;
        this.waterResultsLayer.clearLayers();
      },
      drawStart() {
        /* Initialize the drawing functionality */
        this.map.getPane('draw').style.zIndex=1000
        this.statusMessage = this.statusType = null
        this.map.fire("zoomend")

      },
      drawStop() {
        this.map.getPane('draw').style.zIndex=0;
        this.map.removeControl(this.drawHelper);
        this.map.removeControl(this.drawControl);
        this.drawnItems.clearLayers();
        this.geom = null;
      },
      uploadStart() {
        this.statusMessage = this.statusType = null
        this.map.getPane('upload').style.zIndex=1000
        this.statusMessage = 'Upload a georeferenced file to define an area of interest.'
        this.statusType = 'info'
        //this.map.addLayer(this.fileuploadLayer)
      },
      uploadStop() {
        //this.map.removeLayer(this.fileuploadLayer);
        this.fileuploadLayer.clearLayers();
        this.geom = null;
        this.map.getPane('draw').style.zIndex=0
        
      },
      searchStart() {
        this.map.getPane('search').style.zIndex=1000
        this.$refs.searchInput.focus()
        this.statusMessage = 'Use the search box at the top to find a place.'
        this.statusType = 'info'
      },
      searchStop() {
        this.geom = null;
        this.map.getPane('search').style.zIndex=0
        this.searchResultsLayer.clearLayers();
      },
      zoomIn(bounds) {
        this.zoomHelper.remove();
        this.map.fitBounds(bounds);
        this.drawActive = true
      },
      mkIcon(className, html) {
        className = className ? className : '';
        html = html ? html : '';
        return L.divIcon({className: className, 
                          html:html,
                          iconSize:[320, 28], 
                          iconAnchor: [160, 50]});
      },
      searchFor(q) {
        this.searchBusy = true;
        this.statusType = this.statusMessage = null;
        this.statusType = 'info';
        this.statusMessage = "Searching, please wait...";
        this.$axios
           .get(process.env.VUE_APP_API+"/tools/create/search", { params: { q: this.searchQuery } }, {timeout: 4})
           .then(response => {
              this.searchResults = response.data.results;
              this.searchBusy = false;
              if(this.searchResults.length == 0) {
                this.statusType = 'error';
                this.statusMessage = "No results found. Please try again!";
              } else {
                this.statusMessage = 'Found '+this.searchResults.length+' results within the area size limits.'
                this.statusType = 'info'
              }
           })
           .catch(error => {
              this.searchResults = [];
              this.searchBusy = false;
              this.statusType = 'error';
              this.statusMessage = "An error occurred while searching.";
           })
      },
      searchWatershed(lat, lon) {
        this.waterBusy = true;
        this.statusType = 'info';
        this.statusMessage = "Searching, please wait...";
        this.$axios
           .get(process.env.VUE_APP_API+"/tools/create/watershed", { params: { 'lat': lat, 'lng': lon } }, { timeout: 4 })
           .then(response => {
              if(response.data.results != null) {
                this.statusType = this.statusMessage = null;
                this.proposeWatershed(response.data.results[0])
                this.waterBusy = false;
              } else {
                this.statusMessage = 'No watersheds found here. Please try again.'
                this.statusType = 'error'
                this.waterStop();
              }

           })
           .catch(error => {
              this.waterBusy = false;
           })
      },

      initializeChooseArea() {

        /* Initialize the upload functionality */
        this.uploadFile = new Dropzone(this.$refs.uploadContainer, {
          url: process.env.VUE_APP_API+'/tools/create/upload',
          method: "POST",
          maxFilesize: 12,
          parallelUploads: 1,
          addRemoveLinks: true,
          dictCancelUpload: "",
          autoProcessQueue: true,
          dictRemoveFile: "x",
          clickable: this.$refs.btnUpload,
          headers: {
            "Accept": "application/json",
            "Cache-Control": null,
            "X-Requested-With": null,
            'X-CSRFTOKEN': this.csrfcookie(),
            'Authorization': "Token "+this.apitoken()
          }
        });
        this.uploadFile.on("addedfile", (file) => {
          this.fileuploadLayer.clearLayers();
          this.$refs.btnUpload.blur();
          this.uploading = true;
          this.statusType = "info"
          this.statusMessage = "Uploading file, please wait..."
          
        })
        this.uploadFile.on("uploadprogress", (file, progress) => {
          //this.uploadMessage = "Uploading file, please wait... ("+parseInt(progress)+"%)"
        })
        this.uploadFile.on("error", (file, response) => {
          this.statusMessage = "Could not parse the uploaded file!"
          this.statusType = "error"
          this.uploading = false;
        });
        this.uploadFile.on("success", (file, response) => {
          var layer = L.GeoJSON.geometryToLayer(response['geojson'])
          this.fileuploadLayer.addLayer(layer);
          this.proposeShape(layer);
          this.map.fitBounds(this.fileuploadLayer.getBounds())
          this.uploadMessage = null;
          this.uploading = false;
        });

        /* Initialize the base map */
        this.map = L.map(this.$refs.map, {
          'attributionControl': false,
          'scrollWheelZoom': false,
          'zoomControl': false,
          'minZoom':3
        }).setView([28, 12], 2);

        L.control.scale().addTo(this.map);

        /* Initialize the panes for different functionalities */
        this.map.createPane('draw')
        this.map.getPane('draw').style.zIndex=0
        this.map.createPane('upload')
        this.map.getPane('upload').style.zIndex=0
        this.map.createPane('search')
        this.map.getPane('search').style.zIndex=0



        this.map.on("zoomend", (e) => {
          if(this.createMode=='draw') {
            if(this.map.getZoom() >= 8) {
              this.statusMessage = 'Use the draw controls to draw an area of interest. '
              this.statusType = 'info'
              /* we can draw */
              if(this.drawHelper) {
                this.map.addControl(this.drawHelper);  
              }
              if(this.drawControl) {
                this.map.addControl(this.drawControl);  
              }
              this.drawActive = true;
            } else {
              /* zoom in futher to draw */
              this.statusMessage = 'You must zoom in further to draw an area of interest.'
              this.statusType = 'info'
              if(this.drawHelper) {
                this.map.removeControl(this.drawHelper);  
              }
              if(this.drawControl) {
                this.map.removeControl(this.drawControl);  
              }
              if(this.zoomControl) {
                //this.zoomControl.disable()
              }
            }
          }
        });
        this.map.on("click", (e) => {
          if(this.createMode == 'draw' && this.map.getZoom() < 8) {
            this.map.setView(e.latlng, this.map.getZoom()+3)
          }
        });

        this.map.on("click", (e) => {
          if(this.createMode == 'water') {
            var latlng = this.map.mouseEventToLatLng(e.originalEvent);
            this.searchWatershed(latlng.lat, latlng.lng)
          }
        })


        this.zoomControl = L.control.zoom({position:'topright'});
        this.zoomControl.addTo(this.map);

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '',
          maxZoom: 18
        }).addTo(this.map);

        /* Initialize the drawing layers */
        this.fileuploadLayer = new L.FeatureGroup({pane: 'upload'});
        this.map.addLayer(this.fileuploadLayer);

        this.drawnItems = new L.FeatureGroup({pane: 'draw'});
        this.map.addLayer(this.drawnItems);

        this.searchResultsLayer = new L.FeatureGroup({pane: 'search'});
        this.map.addLayer(this.searchResultsLayer);


        this.waterResultsLayer = new L.FeatureGroup({pane: 'water'});
        this.map.addLayer(this.waterResultsLayer);

        /* Initialize the draw and zoom helpers. These will be added to the map
           when required. */
        this.drawControl = new L.Control.Draw({
           draw: {
              marker: false,
              line:false, 
              polyline: false,
              circle:false,
              circlemarker:false,
              polygon: {}
           },
           edit: {
               featureGroup: this.drawnItems,
               edit:false,
               remove:false,
               polygon: {}
           },
           position: 'topleft'
         });

         this.map.on(L.Draw.Event.DRAWSTART, (event) => {
            if(this.createMode=='draw') {
              this.drawHint = false;
            }
         })
         this.map.on(L.Draw.Event.CREATED, (event) => {
            if(this.createMode=='draw') {
              this.drawnItems.clearLayers();
              var layer = event.layer;
              var latlngs = layer._defaultShape ? layer._defaultShape() : layer.getLatLngs()
              var area = L.GeometryUtil.geodesicArea(latlngs);
              layer.options.editing || (layer.options.editing = {});
              layer.editing.enable();
              layer.on('edit', (event) => {
                this.proposeShape(event.target);
              })
              this.drawnItems.addLayer(layer);
              this.proposeShape(layer);
              //this.map.fitBounds(this.drawnItems.getBounds())
            }
          });


        L.Control.DrawHelper = L.Control.extend({
          onAdd: function(map) {
            var div = L.DomUtil.create('div');
            div.innerHTML = '<div>Use the draw controls to draw a polygon or rectangle in this area</div>';
            div.className='drawHelper';
            return div;
          }
        });

        this.drawHelper = new L.Control.DrawHelper({position:'topleft'});

        /* Create a custom GridLayer to help with zooming in and out quickly */
        L.GridLayer.ZoomHelper = L.GridLayer.extend({
          createTile: function(coords) {
            const tile = document.createElement('div');
            var size = this.getTileSize();
            tile.innerHTML = "<a class='grid' href='#' style='width:"+size.x+"px;height:"+size.y+"px;' onclick='return false;'></a>"
            return tile;
          },
        });
        L.gridLayer.zoomHelper = function (opts) {
          return new L.GridLayer.ZoomHelper(opts);
        };
        this.zoomhelper = L.gridLayer.zoomHelper({tileSize:36, minZoom:1, maxZoom:7, pane: 'draw'});
        this.map.addLayer(this.zoomhelper);

        this.doDraw();

        this.$nextTick(() => {
            this.map.invalidateSize();
        });

      },
    proposeSearchResult(result) {
      this.searchResultsLayer.clearLayers();
      var customLayer = L.geoJson(null, {
          interactive: false,
          style: function(feature) {
              return {
                  "color": "#e50000",
                  "weight": 3,
                  "opacity": 1,
                  "fillOpacity": 0.2
              };
          }
      }); 
      var layer = omnivore.wkt.parse(result["wkt"], null, customLayer);
      this.searchResultsLayer.addLayer(layer);
      this.map.fitBounds(this.searchResultsLayer.getBounds())
      this.proposeShape(layer, result["area"], result["wkt"]);
    },
    proposeWatershed(result) {
      this.waterResultsLayer.clearLayers();
      var customLayer = L.geoJson(null, {
          interactive: false,
          style: function(feature) {
              return {
                  "color": "#e50000",
                  "weight": 3,
                  "opacity": 1,
                  "fillOpacity": 0.2
              };
          }
      }); 
      var layer = omnivore.wkt.parse(result["wkt"], null, customLayer);
      this.waterResultsLayer.addLayer(layer);
      this.map.fitBounds(this.waterResultsLayer.getBounds())
      this.proposeShape(customLayer, result["area"], result["wkt"]);
    },
    proposeShape: function(layer, area, wkt) {
      var minarea = this.areaLimitMin;
      var maxarea = this.areaLimitMax;

      var km2 = 0;
      if(area) {
        km2 = area / 1000000
      } else {
        var latlngs = layer._defaultShape ? layer._defaultShape() : layer.coordsToLatLng()
        km2 = L.GeometryUtil.geodesicArea(latlngs)/1000000;
      }
      if(km2 > maxarea) {
        layer.setStyle({color: "red"});
        //this.noticeMarker.setIcon(this.mkIcon('error','Area of '+parseInt(km2)+' sq. km. is too large. Max is '+maxarea+' sq. km.'))
        //this.noticeMarker.setLatLng(layer.getBounds().getCenter())
        this.geomValid = false;
        this.statusMessage = 'Your area ('+parseInt(km2)+'km&#178;) is too large. Max is '+maxarea+'km&#178;.'
        this.statusType = 'error'
      } else if (km2 < minarea) {
        layer.setStyle({color: "red"});
        var statusMessage = 
        //this.noticeMarker.setIcon(this.mkIcon('error','Area of '+parseInt(km2)+' sq. km. is too small. Min is '+minarea+' sq. km.'))
        //this.noticeMarker.setLatLng(layer.getBounds().getCenter())
        this.geomValid = false;
        this.statusMessage = 'Area of '+parseInt(km2)+'&#178; sq. km. is too small. Min is '+minarea+' sq. km.'
        this.statusType = 'error'
      } else {
        this.statusMessage = 'Your area of '+parseInt(km2)+'km&#178; is within the size limits.'
        this.statusType = 'success'
        layer.setStyle({color: "green"});
        this.geomValid = true;
        
      }
      if(wkt) {
        this.geom = wkt;
      } else {
        this.geom = stringify(layer.toGeoJSON())  
      }

    },
    suggestName: function(areaName) {
      if(this.areaName == "") {
        this.areaName = areaName;
      } else {
        // Skip if name already defined.
      }
    },
    generateFactsheet: function() {
      this.$refs.btnSubmit.blur();
      this.$refs.areaNameInput.blur();
      this.working = true
      var params = {
        'location': this.geom,
        'name': this.areaName,
        'factsheettype_requested': this.factsheettype_requested
      }
      const headers = {
        'X-CSRFTOKEN': this.csrfcookie(),
        'Authorization': "Token "+this.apitoken()
      }
      this.statusMessage = 'Creating factsheet... This may take a few seconds.'
      this.statusType = 'info'
      this.$axios
         .post(process.env.VUE_APP_API+"/api/location/", params, { headers: headers })
         .then(response => {
            var factsheetIdentifier = response.data.factsheets[0].identifier;
            this.working = false;
            this.$router.push({name: 'factsheet', params: {factsheet_id: factsheetIdentifier} })
            this.createStop();
         })
         .catch(error => {
            var errorMessage = "Something unexpectedly went wrong."
            if(error.response.data["message"]) {
              errorMessage = error.response.data["message"];
            }
            if(error.response.data["non_field_errors"]) {
              errorMessage = error.response.data["non_field_errors"][0];
            }
            this.statusType = 'error';
            this.statusMessage = "An error occurred: "+errorMessage;
            this.working=false;
         })

    }
    },
  };
</script>


<style>
  li.nav-item .active {
    background-color:#ddd;
  }
  .statusContainer {
    padding-left:10px;
    padding-bottom:8px;
    padding-top:7px;
    margin-top:10px;
    background-color:#fff;
    min-height:35px;
    border:0px solid #ddd;
    
  }
  a.grid {
    background-color:rgba(0,0,0,0.11);
    cursor: pointer; 
    pointer-events: auto;
    display:block;
    border-left:1px solid rgb(0,0,0,0.2);
    border-top:1px solid rgb(0,0,0,0.2);
  }
  a.grid:hover {
    background:none;
  }
  .error {
    color:white;
    background-color:rgba(220,53,69,0.98);
    background-color:rgba(0,0,0,0.5);
    border-radius:3px;
    text-align:center;
    font-weight:bold;
    padding-top:5px;
  }
  .ok {
    color:white;
    background-color:rgba(40,167,69,0.9);
    background-color:rgba(0,0,0,0.5);
    border-radius:3px;
    text-align:center;
    font-weight:bold;
    padding-top:5px;
  }
  div.drawHelper {
    pointer-events:none;
    padding-bottom:8px;
  }
  div.drawHelper div {
    background-color:rgba(0,0,0,0.5);
    padding:6px 10px 6px 10px;
    border-radius:3px;
    color:#fff;
    font-weight:bold;
  }
  div.drawHelper::before {
      position: absolute;
      bottom: 0;
      left: 9px;
      width: 0;
      height: 0;
      border-top: 8px solid rgba(0,0,0,0.5);;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
      content: '';
  }
  div#uploadContainer {
    display:none;
  }
  button#btnUpload {

  }
  div.progress {
    border-radius:0px;
    height:10px;
  }
  div#progress-indicator {
    padding:10px; 
    background-color:#f9f9f9;
    border:1px solid #e5e5e5;
  }

  div.searchResults {
    //position:absolute;
    //top:60px;
    width:100%;
    max-height:100px;
    border:0px solid red;
    z-index:9999999999999999999;
    padding:0px;
    overflow-y:scroll;
  }
  div.searchResults td.name,
  div.searchResults th.name {
     max-width: 375px;;
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     padding-left:10px;
     padding-right:10px;
  }
  div.searchResults td.area {

  }
  div.searchResultsWrapper {
    padding:10px;
    padding-top:5px;
    padding-bottom:5px;
    background-color:rgba(255,255,255,1);
  }
</style>

<style scoped>
  div.map {
    width: 100%;
    height: 350px;
  }
  p {
    font-size:1.1em;
    color:#666;
  }


</style>
